
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPlusMinus as ObiPlusMinusElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-plus-minus.js';
 
 
 

 
 export const ObiPlusMinus = createComponent({
   react: React,
   tagName: 'obi-plus-minus',
   elementClass: ObiPlusMinusElement,
   events: {
     
   }
  });
 
 